import { CheckCircle2 } from 'lucide-react';
import { CtaLink, Eyebrow, OrbitalMotif, ProductFrame } from '../shared/blocks';
import { HERO_LABELS } from './homeContent';

export function HomeHero() {
  return (
    <section className="relative overflow-hidden bg-mk-midnight text-white" data-testid="home-hero">
      <div className="absolute inset-0 bg-[radial-gradient(55%_70%_at_78%_35%,rgba(8,120,249,0.28),transparent_65%)]" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-20 sm:pt-20 lg:pt-24 lg:pb-28 grid lg:grid-cols-[1fr_1.15fr] gap-12 lg:gap-14 items-center">
        <div className="mk-rise">
          <Eyebrow dark className="mb-6">AI-Powered Academic Productivity</Eyebrow>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.04]" data-testid="home-hero-heading">
            Teach Smarter.<br />Prepare Better.<br /><span className="text-mk-cyan">Do More with AI.</span>
          </h1>
          <p className="mt-6 text-base sm:text-lg text-slate-300 max-w-xl leading-relaxed">
            ActanonEdu is an AI-powered education platform for teachers and schools. Lesson plans, assessments and teaching resources — aligned to your board, ready in minutes.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <CtaLink to="/signup" arrow testid="home-hero-cta-primary">Get Started</CtaLink>
            <CtaLink to="/#bosco-ai" variant="ghostDark" testid="home-hero-cta-bosco">Explore BOSCO AI</CtaLink>
          </div>
          <ul className="mt-8 flex flex-wrap gap-x-5 gap-y-2" aria-label="Capabilities">
            {HERO_LABELS.map((l) => (
              <li key={l} className="flex items-center gap-1.5 text-sm text-slate-300">
                <CheckCircle2 className="h-4 w-4 text-mk-cyan" aria-hidden="true" /> {l}
              </li>
            ))}
          </ul>
        </div>
        <div className="relative mk-rise [animation-delay:120ms]">
          <OrbitalMotif className="-inset-16 hidden sm:block" />
          <ProductFrame src="/product/workspace.webp" alt="ActanonEdu AI teaching workspace with Quick task, Plan a lesson kit and Ask BOSCO AI" label="ActanonEdu · Teaching workspace" eager dark className="relative" testid="hero-product-screenshot" />
          <figure className="hidden md:block absolute -bottom-10 -left-8 w-[46%] rounded-xl overflow-hidden border border-mk-line bg-white shadow-[0_24px_50px_-20px_rgba(7,20,38,0.6)]" data-testid="hero-ask-bosco-panel">
            <img src="/product/ask-bosco-panel.webp" alt="Ask Bosco co-pilot panel with suggested prompts" width="420" height="272" className="block w-full h-auto" />
          </figure>
        </div>
      </div>
    </section>
  );
}
